

import Vue from 'vue'
import Tooltip from '@/common/components/Tooltip.vue'
import LocalStorageSerializer from '@/common/localStorageSerializer'
import ColorItem from '@/common/components/ColorItem.vue'

import Const from '@/editor/const'
import { mapGetters } from 'vuex'

export default Vue.extend({
  components: {
    Tooltip,
    ColorItem
  },
  data(): {
    showPrintableColors: boolean,
    skuColorId: string
  } {
    return {
      showPrintableColors: false,
      skuColorId: ''
    }
  },
  computed: {
    ...mapGetters(['product']),
    isPrintableSpecialColors(): boolean {
      return this.product.sku_printable_special_colors.length
    },
    toggleButtonText(): string {
      return this.showPrintableColors ? '印刷可能な印刷色を非表示にする' : '印刷可能な印刷色を確認する'
    }
  },
  watch: {
    isPrintableSpecialColors(value: boolean) {
      if (!value) this.showPrintableColors = value
    }
  },
  methods: {
    togglePrintableColors() {
      this.showPrintableColors = !this.showPrintableColors
    },
    setCurrentPrintColor(payload) {
      LocalStorageSerializer.set(Const.CURRENT_PRINT_COLOR_KEY,payload)
      this.skuColorId = payload.id
    }
  }
})
